<template>
  <ul>
    <li>資料及圖片、影片只供參考，一切以實物為準。</li>
    <li>
      電子優惠券一經滑動，即屬「已兌換」。若換領優惠前，因任何原因而使用或遺失此券，恕不獲補發。
      請確保在網絡穩定的情況下使用此券，因網絡不穩等問題導致未能換領優惠，U Lifestyle 概不負責。
    </li>
    <li>
      會員須同意接受《UU積FUN賞》<a href="https://www.ulifestyle.com.hk/res/static/v3/tandc.html" target="_blank">服務條款</a>及U Lifestyle的
      <a href="https://www.ulifestyle.com.hk/aboutus" target="_blank">私隱條款、服務條款</a>
      及此活動之一切細則及條款。
    </li>
    <li v-if="isUFUN">
      所有禮遇均不得退回或更換其他禮遇，而 U Fun 亦不會退回。
    </li>
    <li>U Fun 並無金錢價值，不能以任何方式兌換現金。</li>
    <li>
      有關禮遇/相關產品之品質、用後反應、使用及服務條款，U Lifestyle 概不負責。
    </li>
    <li v-if="isUFUN">
      U Lifestyle 保留權利隨時自行更改、撤回或終止所有計劃、獎賞、禮遇、條款及細則，任何改動將於 U Lifestyle 各頻道之會員專區內公開發佈，不另作通知。
    </li>
    <li v-else>
      U Lifestyle 保留隨時更改貨品的價格及其他資料的權利，變更的內容將於本頁面直接更新，不另外作出通知。
      若用戶於價格及資料變更後繼續購買，即代表用戶同意及接納變更後的收費。產品及價格以實際交易時的資料及價格為準。
    </li>
    <li>以上優惠是用戶與商戶之間的交易，U Lifestyle概不會負上任何責任。</li>
    <li>如有任何爭議，U Lifestyle保留最終決定權。</li>
  </ul>
</template>

<script>
export default {
  props: {
    isUFUN: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
a:hover {
  text-decoration: underline;
}

ol {
  padding: 0;
  margin-left: 22px;
  font-size: 0.7rem;;

  li {
    line-height: 20px;
    padding-bottom: 10px;
  }
}
</style>
